import { useMemo } from 'react';
import { DOTS } from './PaginationDots';

const range = (start: number, end: number) =>
  Array.from({ length: end - start + 1 }, (_, index) => index + start);

interface Props {
  totalPageCount: number;
  currentPage: number;
  startAt?: number;
  siblingCount?: number;
}

export const usePagination = ({
  totalPageCount,
  currentPage,
  startAt = 1,
  siblingCount = 1,
}: Props) => {
  const paginationRange = useMemo(() => {
    if (siblingCount + 5 >= totalPageCount) return range(1, totalPageCount);

    const itemCount = 3 + 2 * siblingCount;

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);

    const showLeftDots = leftSiblingIndex > 2;
    const showRightDots = rightSiblingIndex < totalPageCount - 2;

    const isAtStart = !showLeftDots && showRightDots;
    const isAtEnd = showLeftDots && !showRightDots;

    if (isAtStart) return [...range(1, itemCount), DOTS, totalPageCount];
    if (isAtEnd) return [startAt, DOTS, ...range(totalPageCount - itemCount + 1, totalPageCount)];

    return [startAt, DOTS, ...range(leftSiblingIndex, rightSiblingIndex), DOTS, totalPageCount];
  }, [totalPageCount, siblingCount, currentPage]);

  return paginationRange;
};
